import { formatDistanceToNow, format } from "date-fns";

export function utc(date: string | Date): Date {
  if (typeof date === "string" && !date.endsWith("Z") && !date.includes("+")) {
    return new Date(date + "Z");
  }
  return new Date(date);
}

export function timeAgo(date: string | Date): string {
  return formatDistanceToNow(utc(date), { addSuffix: true });
}

export function formatDateTime(date: string | Date): string {
  return format(utc(date), "MMM d, yyyy h:mm a");
}

export function formatDate(date: string | Date): string {
  return format(utc(date), "MMM d, yyyy");
}

export function formatMonthYear(date: string | Date): string {
  return format(utc(date), "MMM yyyy");
}

export function formatDateTime24h(date: string | Date): string {
  return format(utc(date), "MMM d, yyyy HH:mm");
}
